type Delimiter = "\n" | "," | ";" | "|" | "\t";

export function parseDelimitedText(text: string, delimiter: Delimiter = "\n"): string[] {
    return text
        .split(delimiter)
        .map(s => s.trim())
        .filter(s => s !== "");
}
